import keycloak from "./keycloak";

// Synchronous logout — builds the KC end-session URL and navigates the browser
// directly. Bypasses Recoil/React state because the previous logoutAtom + effect
// path raced React's re-render: setUser(null) re-mounted <Login /> whose
// onLoad: "check-sso" silently re-authenticated us before window.location
// .replace from the effect actually ran. Keeping this purely imperative — call
// it from any logout button's onClick.
export const logoutAndRedirect = () => {
	const stored = sessionStorage.getItem("kc-tokens");
	const idToken = stored ? JSON.parse(stored).idToken : undefined;
	sessionStorage.removeItem("kc-tokens");
	sessionStorage.removeItem("user");

	const { url, realm, clientId } = keycloak.getConfig();
	const logoutUrl = new URL(`${url}/realms/${realm}/protocol/openid-connect/logout`);
	logoutUrl.searchParams.set("client_id", clientId);
	// Trailing slash matters: KC validates post_logout_redirect_uri against the
	// realm client's post.logout.redirect.uris pattern (e.g. ".../*"), and a
	// bare origin without a trailing slash doesn't match.
	logoutUrl.searchParams.set("post_logout_redirect_uri", `${window.location.origin}/`);
	if (idToken) {
		logoutUrl.searchParams.set("id_token_hint", idToken);
	}
	window.location.replace(logoutUrl.toString());
};
